var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_phone",
    clipPath: "url(#clip0_5196_94636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33366 5.98902V28.0105H22.667V5.98902H9.33366ZM8.00033 3.23633H24.0003C24.3539 3.23633 24.6931 3.38134 24.9431 3.63945C25.1932 3.89756 25.3337 4.24764 25.3337 4.61267V29.3869C25.3337 29.7519 25.1932 30.102 24.9431 30.3601C24.6931 30.6182 24.3539 30.7632 24.0003 30.7632H8.00033C7.6467 30.7632 7.30757 30.6182 7.05752 30.3601C6.80747 30.102 6.66699 29.7519 6.66699 29.3869V4.61267C6.66699 4.24764 6.80747 3.89756 7.05752 3.63945C7.30757 3.38134 7.6467 3.23633 8.00033 3.23633ZM16.0003 23.8815C16.3539 23.8815 16.6931 24.0265 16.9431 24.2846C17.1932 24.5427 17.3337 24.8928 17.3337 25.2578C17.3337 25.6229 17.1932 25.9729 16.9431 26.2311C16.6931 26.4892 16.3539 26.6342 16.0003 26.6342C15.6467 26.6342 15.3076 26.4892 15.0575 26.2311C14.8075 25.9729 14.667 25.6229 14.667 25.2578C14.667 24.8928 14.8075 24.5427 15.0575 24.2846C15.3076 24.0265 15.6467 23.8815 16.0003 23.8815Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5196_94636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33.0323,
    fill: "white",
    transform: "translate(0 0.483398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.460f9e0279845f82eea52e7ba9204b52.svg";
export { ForwardRef as ReactComponent };